import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

const STORAGE_KEY = "casinomenu.cookieConsent";

type Consent = "accepted" | "necessary" | null;

export function CookieBanner() {
  const { lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const [consent, setConsent] = useState<Consent>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY) as Consent;
      setConsent(saved);
    } catch {
      // ignore
    }
  }, []);

  function save(c: Exclude<Consent, null>) {
    try {
      window.localStorage.setItem(STORAGE_KEY, c);
    } catch {
      // ignore
    }
    setConsent(c);
  }

  if (!mounted || consent) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 p-3 sm:p-4">
      <div className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border border-ink-100 bg-white p-4 shadow-card-hover sm:flex-row sm:items-center">
        <div className="flex-1 text-sm text-ink-700">
          <strong className="block text-ink-900">
            {isSv ? "Vi använder cookies" : "We use cookies"}
          </strong>
          <p className="mt-1">
            {isSv
              ? "Vi använder nödvändiga cookies för att webbplatsen ska fungera och valfria cookies för anonym statistik. Inga personuppgifter delas med casinon. Läs vår "
              : "We use necessary cookies for the site to work and optional cookies for anonymous analytics. No personal data is shared with casinos. Read our "}
            <Link
              to={`${prefix}/${isSv ? "integritetspolicy" : "privacy"}`}
              className="font-semibold text-brand-700"
            >
              {isSv ? "integritetspolicy" : "privacy policy"}
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => save("necessary")}
            className="btn-ghost text-sm"
          >
            {isSv ? "Endast nödvändiga" : "Necessary only"}
          </button>
          <button
            type="button"
            onClick={() => save("accepted")}
            className="btn-primary text-sm"
          >
            {isSv ? "Acceptera alla" : "Accept all"}
          </button>
        </div>
      </div>
    </div>
  );
}
